export default __webpack_public_path__ + "static/media/advantageIcon2.fc94b731.webp";